export default __webpack_public_path__ + "static/media/Techshop1.7930f08c.png";